// extracted by mini-css-extract-plugin
export var circle = "_av-1";
export var exitConfirmationModal = "_av-5";
export var iframe = "_av-0";
export var offline = "_av-3";
export var online = "_av-2";
export var workstationSelectError = "_av-4";